import { createApi } from '@reduxjs/toolkit/query/react';
import {
  TTalentTopPovRunsResponse,
  TTalentTopRaidEncountersResponse,
  TTalentTopRaidPovEncountersResponse,
  TTalentTopRunsResponse,
  TTalentTopRaidEncountersParams,
  TTierTalentTopRunsParams
} from '../../../../../../shared/types/statisticsTypes';
import { networkBaseQuery } from './utils';

export const talentRunsApi = createApi({
  reducerPath: 'talentRunsApi',
  baseQuery: networkBaseQuery,
  endpoints: (builder) => ({
    getTierTalentTopRuns: builder.query<TTalentTopRunsResponse, TTierTalentTopRunsParams>({
      query: (params) => ({ url: '/api/statistics/tier/talents/top-runs', params })
    }),
    getTierTalentTopPovRuns: builder.query<TTalentTopPovRunsResponse, TTierTalentTopRunsParams>({
      query: (params) => ({ url: '/api/statistics/tier/talents/top-pov-runs', params })
    }),
    getTierTalentTopRaidEncounters: builder.query<TTalentTopRaidEncountersResponse, TTalentTopRaidEncountersParams>({
      query: (params) => ({ url: '/api/statistics/tier/talents/top-raid-encounters', params })
    }),
    getTierTalentTopRaidPovEncounters: builder.query<
      TTalentTopRaidPovEncountersResponse,
      TTalentTopRaidEncountersParams
    >({
      query: (params) => ({ url: '/api/statistics/tier/talents/top-raid-pov-encounters', params })
    })
  })
});

export const {
  useGetTierTalentTopRunsQuery,
  useGetTierTalentTopPovRunsQuery,
  useGetTierTalentTopRaidEncountersQuery,
  useGetTierTalentTopRaidPovEncountersQuery
} = talentRunsApi;
